import { Component } from '@angular/core';
import { WishlistToggleComponentDef } from '@df/session/wishlist/wishlist-toggle.component.def';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/resut/result.component';
@Component({
    selector: 'wishlist-remove',
    templateUrl: 'wishlist-remove.html',
    standalone: true,
    imports: [ActionComponent, ResultComponent]
})
export class WishlistRemoveComponent extends WishlistToggleComponentDef {
    remove() {
        if (this.item) {
            return this.wishlist.toggle(this.status, this.item, false);
        }
    }
}
